import { CONFIG, FREE_SHIPPING_THRESHOLD } from 'shared/constants'
import { numberToCurrency } from 'lib/money'
import { Tooltip } from 'baby-design'
import { Info } from 'baby-design/icons'
import { freeShippingFaqPath } from 'lib/urls'
import css from './hero.scss'

const StoreHero = () => (
  <div className={css.StoreHero}>
    <h1 className={css.StoreHero__title}>Babylist Shop</h1>
    <div className={css.StoreHero__body}>
      Curated by experts and tested by parents. Enjoy free shipping on{' '}
      {numberToCurrency(FREE_SHIPPING_THRESHOLD, {
        truncateZeroCents: true,
        unit: '$',
      })}
      +
      <Tooltip
        content={
          <div className={css.StoreHero__tooltip__content}>
            Free standard shipping on orders over $45. Exclusions apply.{' '}
            <a href={freeShippingFaqPath} rel="noreferrer" target="_blank">
              Learn more
            </a>
          </div>
        }
        openOn="click"
        position="bottom"
        trigger={<Info className={css.StoreHero__tooltip__icon} />}
        triggerClassName={css.StoreHero__tooltip}
      />
      and an exclusive {CONFIG.store?.registryDiscountPctDisplay} registry
      discount.
      <Tooltip
        content={
          <div className={css.StoreHero__tooltip__content}>
            Create a Babylist registry to receive 15% off 60 days before your
            baby's due date. Valid only on items sold by Babylist. Registry must
            be active for 30 days. Terms and Conditions apply.
          </div>
        }
        openOn="click"
        position="bottom"
        trigger={<Info className={css.StoreHero__tooltip__icon} />}
        triggerClassName={css.StoreHero__tooltip}
      />
    </div>
  </div>
)

export default StoreHero
